import React from "react";
import { motion } from "framer-motion";
import * as Lucide from "lucide-react";

/** AI tool icon with floating + soft pulse animation. */
export default function AnimatedToolIcon({ name, accent = "" }) {
  const Cmp = Lucide[name] || Lucide.Sparkles;
  return (
    <motion.span
      className={`bx-glow-icon relative ${accent}`}
      initial={{ y: 0 }}
      animate={{ y: [-2, 2, -2] }}
      transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
    >
      <motion.span
        aria-hidden
        className="absolute inset-0 rounded-[12px]"
        style={{ boxShadow: "0 0 0 0 rgba(139,92,246,0.5)" }}
        animate={{ boxShadow: ["0 0 0 0 rgba(139,92,246,0.45)", "0 0 0 10px rgba(139,92,246,0)"] }}
        transition={{ duration: 2.4, repeat: Infinity, ease: "easeOut" }}
      />
      <Cmp size={20} />
    </motion.span>
  );
}
